import React,{ Fragment, useEffect, useContext } from 'react'
import { Box } from '@chakra-ui/react';
import AllOrderDelivery from '../../../component/AllOrderDelivery';
import axios from 'axios'
import { useState } from 'react';
import { Auth } from '../../../component/Auth';
import { Context } from '../../../component/store';

const OutForDelivery = () => {
  const [tData, setTData] = useState([])
  const [isLoading, setIsLoading] = useState({loading: true, error: false})

  const { userData } = useContext(Context)
  const user = userData
  const userPermission = user.UserGroupPermission
  const partyId = user.partyId
  // const user = JSON.parse(localStorage.getItem("user"))
  // const userPermission = user.UserGroupPermission
  // const partyId = user.partyId
  useEffect(() => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/all/delivery`,
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
    };
    
    axios.request(config)
    .then((response) => {
      if(user.userGroupMember.includes('ADMIN') || (user.userGroupMember.includes('MEMBER') && userPermission.includes('DELIVERY_MANAGEMENT'))){
        setTData(response.data.orders.filter((x) => x.orderStatusId === "ORDER_OUT_FOR_DELIVERY"));
      }else if(user.userGroupMember.includes("DELEVERY_BOY")){
        let party = response.data.orderParties.filter((x) => x.partyId === partyId)
        let data = response.data.orders.filter((x) =>  party.some((y) => y.orderId === x.id))
        setTData(data.filter((x) => x.orderStatusId === "ORDER_OUT_FOR_DELIVERY"))
      }
      setIsLoading({loading: false, error: false})
    })
    .catch((error) => {
      console.log(error);
      setIsLoading({loading: false, error: true})
    });
    
  },[partyId, user.userGroupMember, userPermission])
  return (
    <Fragment>
      <Box p={5} pt={{base: 1, md: 1, lg: 5, xl: 5, '2xl': 5}} px={{base: 3, md: 3, lg: 5, xl: 5, '2xl': 5}} flex="1" w={'100%'} h={'89vh'}>
        <AllOrderDelivery
        title={'Out for Delivery'}
        head={["ORDER ID", "DATE", "TOTAL", "ITEMS", "Delivery Date", "Delivery Status", ""]}
        data={tData}
        isLoading={isLoading}
        />
      </Box>
   </Fragment>
  )
}

export default OutForDelivery